import { useBulkDelete } from '@/shared/lib';
import { functionalActivityApi, type FunctionalActivity } from '@/entities/FunctionalActivity';

export function useFunctionalActivityDelete(
  selectedCount: () => number,
  selectedIds: () => number[],
  onDeleteSuccess: (deletedIds: number[]) => void,
  removeFromSelection: (ids: number[]) => void,
  onModalClose?: () => void
) {
  return useBulkDelete<FunctionalActivity>({
    entityName: {
      singular: 'atividade funcional',
      plural: 'atividades funcionais',
      gender: 'female',
    },
    successMessage: 'Atividade funcional excluída com sucesso.',
    successMessagePlural: 'Atividades funcionais excluídas com sucesso.',
    singleDeleteApi: functionalActivityApi.delete.bind(functionalActivityApi),
    bulkDeleteApi: functionalActivityApi.bulkDelete.bind(functionalActivityApi),
    onDeleteSuccess,
    removeFromSelection,
    selectedCount,
    selectedIds,
    onModalClose,
  });
}
